import { render } from "./Flickity.vue?vue&type=template&id=8e308a14"
import script from "./Flickity.vue?vue&type=script&lang=ts"
export * from "./Flickity.vue?vue&type=script&lang=ts"

import "flickity/dist/flickity.css?vue&type=style&index=0&lang=css"
script.render = render

export default script